(function () {
  function initBB(root) {
    if (!root || root.getAttribute('data-bb-ready')) return;
    root.setAttribute('data-bb-ready', '1');
    var MOTION = root.getAttribute('data-motion') === 'true';
    var SID = root.getAttribute('data-section-id');
    function all(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
    function one(s, c) { return (c || root).querySelector(s); }
    function play(v) { var p = v && v.play && v.play(); if (p && p.catch) p.catch(function () {}); }

    var top = 24;
    function setTop() {
      var h = 0;
      document.querySelectorAll('.shopify-section-group-header-group, header, sticky-header').forEach(function (el) {
        if (root.contains(el)) return;
        var cs = getComputedStyle(el);
        if (cs.position === 'sticky' || cs.position === 'fixed') {
          var r = el.getBoundingClientRect();
          if (r.top <= 1 && r.bottom > 0 && r.bottom < 260) h = Math.max(h, r.bottom);
        }
      });
      top = Math.round(h + 20);
      root.style.setProperty('--bb-top', top + 'px');
    }
    setTop();
    window.addEventListener('resize', setTop);

    all('video[autoplay]').forEach(function (v) { v.muted = true; play(v); });
    all('[data-bb-sound]').forEach(function (b) {
      var v = one(b.getAttribute('data-bb-sound') === 'reel' ? '[data-bb-reel]' : '[data-bb-hero-video]');
      if (!v) { b.hidden = true; return; }
      b.addEventListener('click', function () {
        v.muted = !v.muted;
        if (!v.muted) play(v);
        b.classList.toggle('is-on', !v.muted);
        b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        var l = one('[data-bb-sound-label]', b);
        if (l) l.textContent = v.muted ? 'Sound off' : 'Sound on';
      });
    });

    var eng = one('[data-bb-eng]'), items = all('[data-bb-item]'), pics = all('.bb-eng__panel img'), chip = one('[data-bb-chip]'), bars = all('[data-bb-prog]'), active = 0, sraf;
    var wideMQ = window.matchMedia('(min-width: 940px)');
    function setActive(i) {
      active = i;
      items.forEach(function (it, k) {
        var on = k === i;
        it.classList.toggle('is-active', on);
        var b = one('.bb-eng__row', it);
        if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      pics.forEach(function (p) { p.classList.toggle('is-active', +p.getAttribute('data-index') === i); });
      if (chip && items[i]) chip.textContent = items[i].getAttribute('data-chip') || '';
    }
    function metrics() {
      var st = one('.bb-eng__stage', eng), r = eng.getBoundingClientRect();
      return { r: r, range: Math.max(1, r.height - (st ? st.offsetHeight : 0)) };
    }
    function updateEng() {
      if (!eng || !items.length) return;
      if (!wideMQ.matches) { bars.forEach(function (b) { b.style.transform = 'scaleX(0)'; }); return; }
      var m = metrics(), n = items.length;
      var p = Math.min(1, Math.max(0, (top - m.r.top) / m.range));
      var f = p * n, a = Math.min(n - 1, Math.floor(f)), sub = Math.min(1, f - a);
      bars.forEach(function (b, i) { b.style.transform = 'scaleX(' + (i === a ? sub.toFixed(4) : '0') + ')'; });
      if (a !== active) setActive(a);
    }
    function onScroll() { cancelAnimationFrame(sraf); sraf = requestAnimationFrame(updateEng); }
    function goEng(i) {
      if (!wideMQ.matches || !eng) { setActive(i); return; }
      var m = metrics();
      window.scrollTo({ top: window.scrollY + m.r.top - top + ((i + 0.5) / items.length) * m.range, behavior: 'smooth' });
    }
    if (eng && items.length) {
      items.forEach(function (it, i) { var b = one('.bb-eng__row', it); if (b) b.addEventListener('click', function () { goEng(i); }); });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      updateEng();
      document.addEventListener('shopify:block:select', function (e) { var i = items.indexOf(e.target); if (i > -1) goEng(i); });
    }

    var strip = one('[data-bb-strip]'), thumb = one('[data-bb-thumb]');
    if (strip) {
      var upd = function () {
        var max = strip.scrollWidth - strip.clientWidth;
        var f = Math.max(0.08, strip.scrollWidth ? Math.min(1, strip.clientWidth / strip.scrollWidth) : 1);
        var p = max > 0 ? strip.scrollLeft / max : 0;
        if (thumb) { thumb.style.width = (f * 100) + '%'; thumb.style.left = (p * (1 - f) * 100) + '%'; }
      };
      strip.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
      var by = function (d) { var c = strip.children[0], w = c ? c.getBoundingClientRect().width + 12 : 320; strip.scrollBy({ left: d * w * 2, behavior: 'smooth' }); };
      var pv = one('[data-bb-prev]'), nx = one('[data-bb-next]');
      if (pv) pv.addEventListener('click', function () { by(-1); });
      if (nx) nx.addEventListener('click', function () { by(1); });
      var drag = null, dragged = false, snapT;
      strip.addEventListener('dragstart', function (e) { e.preventDefault(); });
      strip.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        clearTimeout(snapT);
        drag = { x: e.clientX, s: strip.scrollLeft, moved: false, lx: e.clientX, lt: performance.now(), v: 0 };
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved) { if (Math.abs(dx) < 5) return; drag.moved = true; strip.classList.add('is-dragging'); }
        e.preventDefault();
        strip.scrollLeft = drag.s - dx;
        var t = performance.now();
        drag.v = (e.clientX - drag.lx) / Math.max(1, t - drag.lt);
        drag.lx = e.clientX; drag.lt = t;
      });
      var endDrag = function () {
        if (!drag) return;
        var d = drag; drag = null;
        if (!d.moved) return;
        dragged = true; setTimeout(function () { dragged = false; }, 0);
        var pad = parseFloat(getComputedStyle(strip).paddingLeft) || 0, sl = strip.getBoundingClientRect().left;
        var target = strip.scrollLeft - d.v * 260, best = strip.scrollLeft, bd = Infinity;
        Array.prototype.forEach.call(strip.children, function (c) {
          var pos = c.getBoundingClientRect().left - sl + strip.scrollLeft - pad, dd = Math.abs(pos - target);
          if (dd < bd) { bd = dd; best = pos; }
        });
        strip.scrollTo({ left: Math.max(0, best), behavior: 'smooth' });
        snapT = setTimeout(function () { strip.classList.remove('is-dragging'); }, 500);
      };
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
      strip.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); e.stopPropagation(); } }, true);
    }

    var bar = one('[data-bb-bar]'), req = one('[data-bb-request]');
    if (bar && req && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(req);
    }

    document.addEventListener('shopify:section:unload', function (e) {
      if (e.detail && e.detail.sectionId === SID && root._bbMotion) { root._bbMotion.revert(); root._bbMotion = null; }
    });

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!MOTION || reduce) { root.classList.add('bb-nomotion'); return; }

    function load(src) {
      return new Promise(function (res, rej) {
        var s = document.createElement('script');
        s.src = src; s.async = false; s.onload = res; s.onerror = rej;
        document.head.appendChild(s);
      });
    }
    function start() {
      var g = window.gsap, ST = window.ScrollTrigger;
      if (!g || !ST || root._bbMotion) return;
      g.registerPlugin(ST);
      root._bbMotion = g.context(function () {
        var hero = one('[data-bb-hero]'), txt = one('[data-bb-hero-text]');
        if (hero && txt) g.to(txt, { y: 90, opacity: 0.2, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
        var words = all('[data-rw]'), block = one('[data-bb-reveal]');
        if (words.length && block) g.fromTo(words, { opacity: 0.12 }, { opacity: 1, ease: 'none', stagger: 0.1, scrollTrigger: { trigger: block, start: 'top 82%', end: 'bottom 52%', scrub: 0.6 } });
        all('[data-up]').forEach(function (el) { g.from(el, { y: 56, opacity: 0, duration: 1.1, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 90%', once: true } }); });
        all('[data-bb-frame]').forEach(function (wrap) {
          var el = wrap.firstElementChild;
          if (!el) return;
          g.fromTo(el, { scale: 0.82, borderRadius: 28 }, { scale: 1, borderRadius: 0, ease: 'none', scrollTrigger: { trigger: wrap, start: 'top bottom', end: 'top 25%', scrub: 0.6 } });
          g.fromTo(el, { opacity: 1, filter: 'brightness(1)' }, { opacity: 0.2, filter: 'brightness(0.45)', ease: 'none', immediateRender: false, scrollTrigger: { trigger: wrap, start: 'bottom 40%', end: 'bottom top', scrub: 0.6 } });
        });
      }, root);
      window.addEventListener('load', function () { ST.refresh(); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ST.refresh(); });
    }
    if (window.gsap && window.ScrollTrigger) start();
    else (window.gsap ? Promise.resolve() : load('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js'))
      .then(function () { return window.ScrollTrigger ? null : load('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js'); })
      .then(start)
      .catch(function () {});
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-bb-root]').forEach(initBB); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* Hulk form restyle: Hulk applies its own inline/!important styles (white labels, centered fixed-width card), so enforce ours inline with !important after it renders. */
(function () {
  var INK = '#0D0D0D', LINE = '#D4D4D4', FONT = "'Inter',system-ui,-apple-system,'Segoe UI',sans-serif";
  var FIELD = { 'box-sizing': 'border-box', 'width': '100%', 'max-width': 'none', 'height': '52px', 'min-height': '52px', 'padding': '0 20px', 'border': '1px solid ' + LINE, 'border-radius': '999px', 'background-color': 'transparent', 'background-image': 'none', 'box-shadow': 'none', 'outline': 'none', 'color': INK, 'font-family': FONT, 'font-size': '16px', 'font-weight': '400', 'line-height': '1.3', 'letter-spacing': '0', 'text-transform': 'none', 'text-align': 'left', 'opacity': '1' };
  var AREA = {}; for (var k in FIELD) AREA[k] = FIELD[k];
  AREA['height'] = 'auto'; AREA['min-height'] = '180px'; AREA['padding'] = '16px 20px'; AREA['border-radius'] = '16px'; AREA['line-height'] = '1.6';
  var LABEL = { 'color': INK, 'font-family': FONT, 'font-size': '12px', 'font-weight': '600', 'line-height': '1.3', 'letter-spacing': '.08em', 'text-transform': 'uppercase', 'text-align': 'left', 'opacity': '1', 'visibility': 'visible', 'text-shadow': 'none' };
  var CHOICE = { 'color': INK, 'font-family': FONT, 'font-size': '15px', 'font-weight': '400', 'line-height': '1.4', 'letter-spacing': '0', 'text-transform': 'none', 'text-align': 'left', 'opacity': '1', 'visibility': 'visible' };
  var BTN = { 'display': 'inline-flex', 'align-items': 'center', 'justify-content': 'center', 'width': 'auto', 'min-width': '220px', 'height': '58px', 'margin': '16px 0 0', 'padding': '0 30px', 'border': '0', 'border-radius': '999px', 'background': 'var(--bb-ac,#FF2929)', 'box-shadow': 'none', 'color': '#FCFCFC', 'font-family': FONT, 'font-size': '15px', 'font-weight': '600', 'line-height': '1', 'letter-spacing': '.06em', 'text-transform': 'uppercase', 'cursor': 'pointer', 'opacity': '1' };
  var SHELL = { 'width': '100%', 'max-width': 'none', 'margin-left': '0', 'margin-right': '0', 'padding-left': '0', 'padding-right': '0', 'background': 'transparent', 'border': '0', 'box-shadow': 'none', 'text-align': 'left' };
  var PH = 'input::placeholder,textarea::placeholder{color:#8F8F8F!important;opacity:1!important}';
  function set(el, o) { for (var p in o) { if (el.style.getPropertyValue(p) !== o[p] || el.style.getPropertyPriority(p) !== 'important') el.style.setProperty(p, o[p], 'important'); } }
  function lum(c) { var m = (c || '').match(/[\d.]+/g); if (!m || m.length < 3) return 0; if (m.length > 3 && +m[3] < 0.05) return 0; return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255; }
  function isField(el) { var t = el.tagName; if (t === 'SELECT') return true; if (t !== 'INPUT') return false; var ty = (el.getAttribute('type') || 'text').toLowerCase(); return ['checkbox', 'radio', 'submit', 'button', 'file', 'hidden', 'image', 'reset', 'range', 'color'].indexOf(ty) < 0; }
  function isSubmit(el) { if (el.matches('button[type=submit],input[type=submit],input[type=button]')) return true; return el.tagName === 'BUTTON' && /submit|send|request/i.test((el.textContent || '') + ' ' + (el.className || '')); }
  function ownText(el) { for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && n.nodeValue.trim()) return true; return false; }
  function injectPH(root) { if (root.__bbPH) return; root.__bbPH = true; var s = document.createElement('style'); s.textContent = PH; (root.head || root).appendChild(s); }
  function bindFocus(el) {
    if (el.__bbFocus) return; el.__bbFocus = true;
    el.addEventListener('focus', function () { el.style.setProperty('border-color', INK, 'important'); el.style.setProperty('box-shadow', '0 0 0 1px ' + INK, 'important'); });
    el.addEventListener('blur', function () { el.style.setProperty('border-color', LINE, 'important'); el.style.setProperty('box-shadow', 'none', 'important'); });
  }
  function styleTree(node, cw) {
    var els = node.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.shadowRoot) { injectPH(el.shadowRoot); styleTree(el.shadowRoot, cw); watch(el.shadowRoot); }
      if (el.tagName === 'IFRAME') { try { var d = el.contentDocument; if (d && d.body) { injectPH(d); styleTree(d.body, cw); watch(d.body); } } catch (x) {} set(el, { 'width': '100%', 'max-width': 'none' }); continue; }
      if (isField(el)) { set(el, FIELD); if (el.tagName === 'SELECT') el.style.setProperty('padding-right', '44px', 'important'); if (el.closest('.iti,.intl-tel-input')) el.style.removeProperty('padding'); bindFocus(el); continue; }
      if (el.tagName === 'TEXTAREA') { set(el, AREA); bindFocus(el); continue; }
      if (isSubmit(el)) {
        set(el, BTN);
        var kids = el.querySelectorAll('*'); for (var j = 0; j < kids.length; j++) kids[j].style.setProperty('color', '#FCFCFC', 'important');
        var par = el.parentElement;
        if (par) set(par, { 'text-align': 'left', 'justify-content': 'flex-start', 'padding-left': '0', 'margin-left': '0' });
        continue;
      }
      if (el.closest('button[type=submit],input[type=submit]')) continue;
      if (el.tagName === 'INPUT' || el.tagName === 'OPTION') continue;
      var cs = getComputedStyle(el);
      if (/^(DIV|FORM|FIELDSET|SECTION|UL)$/.test(el.tagName) && !el.closest('.iti,.intl-tel-input')) {
        var mw = cs.maxWidth;
        if (/px$/.test(mw) && parseFloat(mw) >= 360 && parseFloat(mw) < cw) set(el, { 'max-width': 'none', 'margin-left': '0', 'margin-right': '0' });
        if (cs.textAlign === 'center') el.style.setProperty('text-align', 'left', 'important');
        if (cs.justifyContent === 'center' && cs.display.indexOf('flex') > -1 && !el.querySelector('input,select,textarea')) el.style.setProperty('justify-content', 'flex-start', 'important');
      }
      if (el.tagName === 'LABEL' || el.tagName === 'LEGEND') {
        var choice = el.querySelector('input[type=checkbox],input[type=radio]') || (el.previousElementSibling && el.previousElementSibling.matches('input[type=checkbox],input[type=radio]'));
        set(el, choice ? CHOICE : LABEL);
        el.querySelectorAll('*').forEach(function (c) { if (lum(getComputedStyle(c).color) > 0.7) c.style.setProperty('color', INK, 'important'); });
        continue;
      }
      if (ownText(el)) {
        if (lum(cs.color) > 0.7) el.style.setProperty('color', INK, 'important');
        if (cs.visibility === 'hidden' && el.closest('label')) el.style.setProperty('visibility', 'visible', 'important');
        if (cs.textAlign === 'center') el.style.setProperty('text-align', 'left', 'important');
        el.style.setProperty('font-family', FONT, 'important');
      }
    }
  }
  var pending = null, watched = [];
  function schedule() { if (pending) return; pending = setTimeout(function () { pending = null; run(); }, 60); }
  function watch(n) { if (watched.indexOf(n) > -1 || !window.MutationObserver) return; watched.push(n); new MutationObserver(schedule).observe(n, { childList: true, subtree: true }); }
  function run() {
    document.querySelectorAll('#bb-hulk').forEach(function (c) {
      c.style.setProperty('text-align', 'left', 'important');
      var cw = c.clientWidth || 9999;
      var sh = c.querySelectorAll('.pxFormGenerator,.formBox,.formContent,form');
      for (var i = 0; i < sh.length; i++) set(sh[i], SHELL);
      styleTree(c, cw);
      watch(c);
    });
  }
  injectPH(document);
  function boot() { run(); var n = 0, t = setInterval(function () { run(); if (++n > 24) clearInterval(t); }, 500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 200); });
})();
